module.exports = __webpack_public_path__ + "img/bord_gais.b1a286b.svg";